/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.6.0-nightly.2026.8.26",
    versionName: "0.6.0-nightly.2026.8.26",
    versionChannel: "nightly",
    buildDate: "2026-08-26T00:12:55.343Z",
    commitHash: "01c06cc056170327c71ba6087a326d3117afe570",
};
